// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../data";
import { FrameHealth } from "../frame-health";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../audio";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";
import {
  initCursorOverlay,
  setEdgeCursorRepaint,
} from "../cursor";
import { resetNetJitter } from "../net-jitter";

export class Game {
  constructor() {
    this.canvas = document.getElementById("game");
    this.ctx = this.canvas.getContext("2d");
    this.W = 0; this.H = 0; this.cx = 0; this.cy = 0; this.scale = 1; this.scaleY = 1;
    this.ax = 0; this.ay = 0;          // arena center in WORLD coords
    this.maxRadius = 400;
    this.platformRadius = 400;
    this.camX = 0; this.camY = 0;      // world point shown at screen center
    this.showHitboxes = false;         // sandbox-only collision overlay (checkbox)

    this.players = [];
    this.playerById = {};
    this.projectiles = [];
    this.mines = [];
    this.sigils = [];
    this.healpods = [];
    this.blizzards = [];
    this.poisonPools = [];
    this.icePatchesDirty = true;
    this.firewalls = [];
    this.hellrips = [];
    this.stickymines = [];
    this.icewalls = [];
    this.voidglass = [];
    this.nullSphereErupts = [];
    this.bossBeams = [];
    this.essenceWards = [];
    this.essenceCast = null;
    this.bloomRipples = [];
    this.particles = [];
    this.shockwaves = [];  // expanding impact rings ({x,y,t,life,r0,r1,color,width,glow})
    this.armPops = [];     // brief detonation flashes (Bloom Pod, …)
    this.spellSpritePops = []; // short cast/impact sprite bursts (Fireball, …)
    this.beams = [];       // short-lived lightning bolts ({x0,y0,x1,y1,t,life,color,seed})
    this.chargeStamps = []; // fading ground marks behind Colossus Charge
    this.spriteTrails = []; // rush + bullet-time movement afterimages
    this.meteorCraters = []; // legacy alias — use floorBurns
    this.floorBurns = []; // scorched arena floor from explosions
    this.bloodStains = []; // hemorrhage drips on the arena floor
    this.plagueStains = []; // faded poison pool marks (Grosh'kar)
    this.frostStains = []; // faded ice patch marks (Vorathal)
    this.meteorNukeClouds = []; // expanding dust cloud from Nuke shockwave
    this.meteorNukeSwamps = []; // toxic mushroom cloud on Nuke detonation
    this.meteorNukeFuses = []; // pulsing ground marker during Nuke fuse
    this.dmgPopups = [];   // floating damage numbers ({x,y,val,t,life,sizePx,...})
    this.pillars = [];
    this.stars = [];
    this.voidDebris = [];
    this.shootingStars = [];
    this._voidShootTimer = 0;
    this.sprites = {};                 // robe color -> pre-rendered sprite canvas
    this._gradCache = new Map();       // cached CanvasGradients keyed by shape params
    this._actorSortScratch = [];       // reused depth-sort buffer (render loop)
    this._uiEls = null;                // lazy-cached HUD DOM refs (loop.ts)
    this._tabHidden = document.hidden;
    this._loopActive = true;
    this._needReconcile = false;
    this._lastReconcile = null;
    this._boundLoop = this.loop.bind(this);
    this.now = 0;                      // performance.now() sampled once per frame (ms)
    this.nowS = 0;                     // this.now in seconds (animation phase)

    this.state = "menu";   // menu | countdown | playing | roundover | shop | matchover
    this.homeView = "home"; // home | find | solo | matchmaker | …
    this.homeAuthReady = false; // false until /auth/me resolves (home menu boot spinner)
    this.homeGuestMode = false; // true after guest/sign-in choice this session (not persisted)
    this.mmPlayerSizes = new Set([2, 3, 4, 5, 6, 7, 8]); // FFA — default "Any" (all sizes)
    this.mmCategory = "pvp"; // pvp | pve
    this.mmPvePlayerSizes = new Set([2, 3, 4]); // PvE — default "Any" (2–4)
    this.mmFormat = "ffa"; // ffa | teams (PVP only)
    this.mmTeamSizes = new Set([2, 3, 4]); // teams — default "Any" (2v2–4v4)
    this.mmTeamCounts = new Set([2, 3, 4]); // teams — default "Any"
    this.mmModes = new Set(["skilldraft"]);
    this.mmRounds = 5;
    this.mmStartGold = 100;
    this._inMatchQueue = false;
    this._mmQueueSince = 0; // performance.now() when match search started
    this._onlineStats = null; // { players, inGame, inQueue } from GET /online
    this._onlinePoll = null;
    this._matchmake = null; // skip lobby UI until match starts (matchmaker)
    this._fromMatchmaking = false; // set when a matchmaker game begins (hides lobby rematch)
    this._fromPractice = false; // set when starting Practice vs Bots; controls menu return
    this._applyCreatePrefs = false;
    this._readyCheck = false;
    this._mmReadied = false;
    this._mmReadyDeadline = 0;
    this._mmFillDeadline = 0;
    this._mmTipActive = false;
    this._mmTipLast = "";
    this._mmTipHideTO = null;
    this._mmTipNextTO = null;
    this._mmQueueCooldownUntil = 0;
    this._queueInvite = null;
    this._queueInviteSnoozeUntil = this.loadQueueInviteSnoozeUntil();
    this._devKeySeq = { key: null, count: 0, at: 0 };
    this._lobbyStartDeadline = 0; // host: performance.now() when lobby start countdown ends
    this._lobbyStartCountN = 0;   // last beeped second (3/2/1)
    this._draftPickCountN = 0;    // last beeped draft-pick second (10…1)
    this.timer = 0;        // generic state timer
    this.roundTime = 0;    // elapsed in current round (for shrink)
    this.roundNumber = 0;
    this.numPlayers = 4;
    this.practiceBotSkill = "master";
    this.matchRounds = CFG.roundsPerMatch;   // rounds in the current match
    this.practiceRounds = CFG.roundsPerMatch; // host-picked rounds for solo practice
    this.practiceStartGold = CFG.practiceStartGold;  // host-picked start gold for solo practice (PVE)
    this.bannerText = "";
    this.roundWinner = null;
    this.roundResultText = ""; // headline drawn above the round-over scoreboard

    // --- networking / mode ---
    this.mode = "local";          // "local" (vs bots) | "remote" (online)
    this.net = null;
    this.myId = -1;
    this.spectating = false;
    this.roundSpectate = false;
    this._roundSpectateTO = null;
    this.spectateWatchId = null;
    this.spectateWatchPending = null;
    this.isHost = false;
    this.lobby = null;
    this.humanCount = 0;          // humans in the current room (drives the mid-match Leave button)
    this._myEffects = [];
    this._watchEffects = []; // spectator: followed player's buffs/debuffs
    this.statusTipKey = null;
    this.snaps = [];              // snapshot buffer for interpolation
    this._interpSnapRecv = 0;     // last s1.recv applied to entity lists
    this.frameHealth = new FrameHealth(); // client perf telemetry → /clientmetrics
    this.decoys = [];             // Illusionist decoys (not players)
    resetNetJitter(this);         // adaptive playout delay (see net-jitter.ts)
    this.maxRadiusServer = 0;
    this._lastAimSent = 0;
    this._lastMoveSent = 0;
    this._lastMoveX = null;
    this._lastMoveY = null;
    this._holdMoveActive = false;
    this._intentionalClose = false;
    this._voidSoundManual = false; // secret Shift+V: force void riser + muffled mix
    // client-side prediction (own wizard) + reconnect
    this.pred = { init: false, moveTarget: null, hasMove: false, knockT: 0, x: 0, y: 0, vx: 0, vy: 0, alive: true, falling: false, stun: false };
    this.creds = null;          // { code, token, name } for reconnect
    this._reconnectTries = 0;
    this._reconnTO = null;

    this.mouse = { x: 0, y: 0, down: false, over: false };
    this.keysHandled = {};
    this.chargingSlot = null; // slot key held for a chargebeam spell
    this.slotDrag = null;     // SHIFT+drag slot reorder { from, spellId, x, y, hover }
    this._hpVialFrac = 1;     // smoothed fill for the HUD blood vial
    this._hpVialPid = null;   // player id the vial frac belongs to
    this._hpVialVel = 0;      // fill rate (frac/s) for liquid slosh
    this._hpVialSlosh = 0;    // decaying wave intensity while level moves

    // scoreboard overlay (hold Tab + toggle button)
    this.scoreboardHeld = false;
    this.scoreboardOpen = false;
    this.sandboxShopOpen = false; // sandbox: spellbook overlay while still in playing
    this.sandboxDraftOpen = false; // sandbox: skill draft overlay while still in playing
    this.sandboxNoCD = false;     // sandbox: server-backed no-cooldown toggle
    this.sandboxStationary = false; // sandbox: dummy stays at spawn
    this.sandboxDummyCount = 0;
    this.sandboxDumbCount = 0;
    this.sandboxSmartCount = 0;
    this.sandboxPlatformFrac = 1;
    this.sandboxLastHitAt = 0;   // performance.now() of last sandboxhit (10s idle UI reset)
    this.sandboxActivity = null; // last activity summary from server
    this.shopReport = null;       // latest CombatReport from the server (online)
    this.reportScope = "round";   // "round" | "match" toggle in the shop view
    this._reportCategory = "spells";
    this._reportTags = new Set();
    this._reportOverride = null;  // { gameId, matchId, source } from openReportCenter
    this._achievementRows = null; // cached achievement catalog rows

    // WASM local-wizard prediction (the same Go sim the server runs). Until it
    // finishes instantiating, the local wizard simply renders from snapshots.
    this.simReady = false;
    this.initSim();

    initCursorOverlay();
    setEdgeCursorRepaint(() => this.syncCustomCursor());
    this.resize();
    this.bindEvents();
    this.buildMenu();
    this.ensureCatalog?.();

    // If this tab was mid-game before a reload, reclaim the seat. Otherwise an
    // /lobby/CODE invite link joins straight away; everyone else lands on home.
    if (typeof window !== "undefined" && window.__PERF_PAGE) {
      // perf.html owns boot — skip lobby UI and session reconnect.
    } else if (!this.tryResumeSession()) {
      const invite = parseLobbyInviteCode();
      if (invite) this.joinFromInvite(invite);
      else { this.showHome(); this.syncMusic(); }
    }

    // Browsers block audio until a gesture; unlock on first interaction with the UI.
    const overlay = document.getElementById("overlay");
    if (overlay) {
      const unlock = () => {
        Sound.resume();
        overlay.removeEventListener("pointerdown", unlock);
        overlay.removeEventListener("keydown", unlock);
      };
      overlay.addEventListener("pointerdown", unlock, { passive: true });
      overlay.addEventListener("keydown", unlock);
    }

    this.last = performance.now();
    requestAnimationFrame(this._boundLoop);
    if (this._tabHidden) this.pauseTabWork();

    // Warm the heavy in-match platform bake during menu idle time so the first
    // match after page load doesn't freeze on its first drawPlatform.
    const warm = () => this.warmPlatformTextures();
    if (typeof requestIdleCallback === "function") requestIdleCallback(warm, { timeout: 4000 });
    else setTimeout(warm, 1500);
  }
}
